module.exports = __webpack_public_path__ + "img/FUT_poznan.9c4bc0b0.png";